
export class DatabaseException extends Error {
  public readonly fatal: boolean;

  constructor(
    public readonly description: string,

    // The optional code to accommodate the message.
    // Allows users to identify the exception from a short code-name.
    public readonly code: string = 'unknown',
    params?: {
      fatal?: boolean
    }
  ) {
    super(description);

    this.fatal = params?.fatal ?? true;
  }

  toString(): string {
    return `[${this.code}] ${this.description}`;
  }
}
